
import Vue from "vue";
import store from "@/store";

export default Vue.extend({
  name: "FactoriesHistoryComponent",

  data() {
    return {
      defaultImage: require("@/assets/img/default-product.jpg"),
      url: "https://webapi.vip-chef.ir/images/landing/",
    };
  },

  computed: {
    factories() {
      return store.state.admin.landing.footerAddressFactories;
    },
  },

  methods: {
    // banner(image: string) {
    //     if (image !== "") {
    //         return this.url + image;
    //     } else {
    //         return "";
    //     }
    // },

    deleteFactoryAddress(id: string): void {
      store.dispatch("admin/deleteFactoryAddress", id);
    },
  },

  created() {
    store.dispatch("admin/getFactoryAddresses");
  },
});
